export interface RiskItem {
  riskId: number;
  riskScore?: number;
  riskSeverity?: number;
  endpointName?: string;
  riskOwner?: string | null;
  riskName?: string;
  riskViolationSummaryObjects?: {
    riskScore?: number;
    violationEntitlementCount?: number;
    violationCount?: number;
  } | null;
  description?: string | null;
  comments?: string | null;
  priority?: string;
  status?: string;
  riskType?: string;
  ruleset?: string;
  function1?: string | null;
  function2?: string | null;
  function3?: string | null;
  function4?: string | null;
  function5?: string | null;
  function1Key?: number | null;
  function2Key?: number | null;
  function3Key?: number | null;
  function4Key?: number | null;
  function5Key?: number | null;
  businessProcess?: string | null;
  analyticsName?: string | null;
  customProperty1?: string | null;
  customProperty2?: string | null;
  customProperty3?: string | null;
  customProperty4?: string | null;
  customProperty5?: string | null;
}

export interface GetInherentRisksApiResponse {
  data: RiskItem[];
  status: number;
  message: string;
  displayRecords: number;
  totalRecords: number;
  page: {
    max: number;
    offset: number;
  };
  sort: {
    order: string;
    columnToSort: string;
  };
}

export interface GetInherentRisksRequest {
  includeDetails: boolean;
  includeViolationSummary: boolean;
  riskKeys: number[];
  entitlementKeys: number[];
  businessProcesses: string[];
  rulesets: string[];
  riskNames: string[];
  riskTypes: string[];
  statuses: string[];
  priorities: string[];
  functionKeys: number[];
  columnToSort: string;
  globalSearch: string | null;
  max: number;
  offset: number;
  order: string;
}

export enum InherentRisksType {
  API_SLICE_NAME = 'aag/inherentRisksApi',
}
